import React from 'react';
import './App.css';
import 'tachyons';
import Content from './Content';
import Contact from './Contact';
import Ebooks from './Ebooks';
import Footer from './Footer';
// import FeaturedEbooks from './Featured Ebooks/Featured Ebooks';


function App() {
  return (
   
    <div >
      
    <div id="Main" className="backgroundImage parallax">

      <div className="menuStyling">
       <a href="#Main"> <h1 className="grow"> Main</h1></a> 
       <a href="#Content"> <h1 className="grow"> About</h1></a> 
       <a href="#Ebooks"> <h1 className="grow"> My Ebooks</h1></a> 
       {/* <a href="#FeaturedEbooks"> <h1 className="grow"> Featured Ebooks</h1></a> */}
       <a href="#Contact"> <h1 className="grow"> Contact</h1></a> 
      </div>

      <div className="wrapStyling f4 f3-m f2-l black-90 mv3">
        <h1>Freelancer For Hire & <br></br>
         Hobbyist Writer</h1>
      </div>
    </div>
    
    <Content />
    <Ebooks />
    {/* <FeaturedEbooks /> */}
    <Contact />
    <Footer />


    </div>
  );
}

export default App;
